export default __webpack_public_path__ + "static/media/home_page.3651c0f8.svg";